import axios from 'axios';

// 会话由服务端 HttpOnly Cookie 管理(同源自动携带),写请求附加 X-CSRF-Token。
const apiClient = axios.create({
  baseURL: '/api',
  timeout: 8000,
  withCredentials: true,
  headers: {
    'X-CSRF-Token': 'cloakchat',
  },
});

apiClient.interceptors.request.use(
  (config) => config,
  (err) => Promise.reject(err),
);

apiClient.interceptors.response.use(
  (response) => response,
  (err) => {
    // 统一把后端 {error} 转为 Error.message
    const data = err?.response?.data;
    if (data && typeof data === 'object' && typeof data.error === 'string') {
      err.message = data.error;
    }
    return Promise.reject(err);
  },
);

export default apiClient;